// @ts-ignore
import { commonEN, enCommonTranslates } from '@g2-shared/common';

export const en = {
  ...commonEN,
  ...enCommonTranslates,
  Options_are_loading: 'Options are loading',
  No_options_found: 'No options found',
  woops: 'Oops! Something went wrong...',
  welcome: 'Welcome!',
  continue: 'Continue',
  saveChanges: 'Save changes',
  apply: 'Apply',
  sendMoney: 'Send money',
  trackTransaction: 'Track transaction',
  menu: 'Menu',
  findLocation: 'Find location',
  findLocationForVerification: 'Find location for identification',
  customerSupport: 'Customer support',
  history: 'History',
  profile: 'Profile',
  logout: 'Logout',
  login: 'Login',
  successLogout: 'Successfully logout',
  hello: 'Hello',
  homeHelloText: 'You will see all important notifications and warnings here.',
  transactionHistory: 'Transaction history',
  latestTransactions: 'Latest transactions',
  description: 'Description',
  mtcn: 'MTCN',
  date: 'Date',
  amount: 'Amount',
  status: 'Status',
  maxAmountTitle: 'Maximum amounts you can send',
  byTransaction: 'By transaction',
  byDay: 'By day',
  byMonth: 'By month',
  en: 'English',
  sr: 'Serbian',
  idCard: 'ID',
  passport: 'Passport',
  refugee_id: 'Refugee ID',
  asylumSeekerId: 'Asylum Seeker ID',
  diplomaticId: 'Diplomatic ID',
  emergencyTravelDocument: 'Emergency travel document',
  militaryIdentificationCard: 'Military identification card',
  convictIdentificationCard: 'Convict identification card',
  foreignId: 'Foreign ID',
  idForeignCitizen: 'ID for foreign citizen',
  drivingLicence: 'Drivers licence',
  successConfirmedVerifyPhoneCode: 'Successfully confirmed phone verification.',
  successSentPhoneVerifyCode: 'Successfully sent code for phone verification.',
  agreeWith: 'I agree with',
  acceptTermsAndConditionsLinkText:
    "Western Union's terms for creating a profile and their online privacy statement.",
  acceptNewsletter:
    'Please inform me about the new terms of Western Union and other special offers. Communication can be via SMS, email, phone, and mail. I can change this in my profile settings at any time.',

  // Profile
  profileManagement: 'Profile management',
  saveUserDetails: 'Save user details',
  notification: 'Notification',
  registrationProcessingText:
    'Your have successfully completed user account registration! In order to be able to use the Western Union online service, you need to confirm your identity:',
  connectToVideoIdentification: 'Connect to the video-identification service',
  or: 'or',
  visitOneOfTenforeLocations: 'Visit one of the Tenfore locations for identity confirmation.',
  // Profile tabs
  personalInfo: 'Personal info',
  userData: 'User data',
  securityIssue: 'Security issue',
  password: 'Password',

  // User personal details
  birthDate: 'Birth date',
  birthPlace: 'Birth place',
  birthCountry: 'Birth country',
  country: 'Country',
  documentType: 'Document type',
  documentIssuer: 'Document issuer',
  documentNumber: 'Document number',
  documentDateOfIssue: 'Document date of issue',
  noExpirationDate: 'Permanent validity of the document',
  documentExpirationDate: 'Document expiration date',
  successUpdatedUserPersonalDetails: 'Successfully updated personal details',
  comment: 'Comment',
  state: 'State',
  documentCountryOfIssue: 'Document country of issue',

  // User details
  address1: 'Address 1',
  address2: 'Address 2',
  phone: 'Phone',
  mobile: 'Mobile',
  successUpdatedUserDetails: 'Successfully updated user details.',
  verified: 'Verified',
  register: 'Register',
  alreadyHaveAccount: 'Already have an account?',
  passwordIsNotValid: 'Passwords do not match',
  successRegisteredUser: 'Successfully registered user',
  successResendEmailVerify: 'Successfully sent verification',
  pleaseCheckMessages: 'Please check your messages!',
  sendCodeText: "We've sent you a 6-digit confirmation code to ",
  secondSendCodeText: '. Please enter the code in the boxes below to verify your phone number.',
  didntGetVerifySms: 'You have not received the confirmation code?',
  resendVerify: 'Resend the code',
  backToLogin: 'Back',
  completeRegister: 'Complete registration',
  completedRegister: 'Successfully created user account.',
  agreeWithWesternUnion: 'I agree with Western Union ',
  termsOfCreateProfile: 'terms of creating profile',
  and: ' and ',
  onlineStatementConfidentiality: 'online statement of confidentiality',
  registerSubscribeText:
    'Inform me about the new terms of Western Union and other special offers. Communication can be through SMS, email, phone, and mail. I can change this in the settings of my profile at any time.',
  dateMustBeInFeature: 'Date must be in feature.',

  // Security issue
  replySecurityIssue: 'Security question answer',
  successUpdatedUserSecurityIssue: 'Successfully updated security question',

  // Password
  currentPassword: 'Current password',
  newPassword: 'New password',
  confirmationNewPassword: 'Confirm password',
  passwordRules:
    'Password must be between 8-16 characters and contain one lowercase character, one uppercase character, one number and one special character.',
  successUpdatedUserPassword: 'Successfully updated password',

  // Send money
  sendMoneyTo: 'Send money to',
  payoutAmount: 'Payout amount',
  paymentAmount: 'Payment amount',
  howDeliveryMoney: 'How would you like the money delivered?',
  howYouWantToPay: 'How would you like to pay?',
  payoutOnLocation: 'Payout at WU location',
  creditDebitCard: 'Credit/Debit card',
  next: 'Next',
  step: 'Step',
  here: 'here',

  // Receiver
  receiverInfo: 'Receiver info',
  noEnteredReceivers: 'No entered receivers',
  successCreatedTransactionReceiver: 'Successfully created receiver',
  successDeletedTransactionReceiver: 'Successfully deleted receiver',
  deleteReceiver: 'Delete receiver',
  addNewReceiver: 'Add new receiver',
  transactionPurpose: 'Purpose',
  residence: 'Residence',
  cancel: 'Cancel',

  // Summary
  summary: 'Summary',
  noDataToDisplay: 'No data to display',
  yes: 'Yes',
  no: 'No',
  transactionAmount: 'Transaction amount',
  wuFee: 'WU transfer fee',
  promoCode: 'Promo code',
  total: 'Total',
  canImmediatePayout: 'Money is available immediately',
  amountForPayout: 'Payout amount',
  successAppliedPromoCode: 'Successfully applied promo code',
  moneyReceivedAs: 'Money received as',
  paidWith: 'Paid with',
  exchangeRate: 'Exchange rate',

  // Disclaimer and liability
  disclaimerTitle: 'Disclaimer and important information',

  // Card
  cardNumber: 'Card number',
  expiryMonth: 'Month',
  expiryYear: 'Year',
  cvc: 'CVC',
  helperTextCvc: '3 or 4 digits on the back of your card',
  addNewCard: 'Add new card',
  paymentInformation: 'Payment information',
  noEnteredCards: 'No entered cards',
  successCreatedCard: 'Successfully created card',
  successDeletedCard: 'Successfully deleted card',
  deleteCard: 'Delete card',
  weAccept: 'We accept',

  // Transaction
  successCreatedTransaction: 'Successfully created transaction',
  back: 'Back',
  transactionId: 'Transaction ID',
  transactionDetails: 'Transaction details',
  details: 'Details',
  withdrawalInformation: 'Withdrawal information',
  sender: 'Sender',
  sentFrom: 'Sent from',
  dateAndTime: 'Date and time',
  receiver: 'Receiver',
  payoutType: 'Payout type',
  paymentType: 'Payment type',
  paymentWithCard: 'Card',
  transactionRate: 'Exchange rate',
  downloadConfirmation: 'Download confirmation',
  repeatTransaction: 'Repeat transaction',
  sendNewTransaction: 'Send new transaction',
  backToHomeScreen: 'Back to home screen',
  visitWesternUnionLocation: 'Visit any Western Union location.',
  findLocationCloseToYou: 'Find a location close to you',
  tellTheAgent: 'Tell the agent I am here to pick up money for a Western Union transfer.',
  mtcnIs: 'Reference number/MTCN is',
  provideIssuedId: 'May need to provide a government issued ID.',
  copiedMtcn: 'Copied MTCN.',
  noTransactions: 'You have no recent transactions',
  completeTransaction: 'Complete transaction?',
  checkDataText: 'Please check if the entered data is correct.',
  sendMoneyNow: 'Send money',
  dateFrom: 'Date from',
  dateTo: 'Date to',
  sendTransaction: 'Send transaction',
  backToPreviousStep: 'Back to previous step',
  newCard: 'New card',
  currency: 'Currency',
  acceptTermsText: 'I agree to the ',
  acceptTermsTextLink: 'terms of service.',
  termsText1:
    'Funds may be delayed or services may be unavailable based on certain transaction conditions, including amount sent, destination country, currency availability, regulatory issues, identification requirements, differences in time zones, agent location hours, time of payment, or selection of delayed options. Additional restrictions may apply. See online',
  termsText2:
    'Western Union also makes money from currency exchange. When choosing a money transmitter, carefully compare both transfer fees and exchange rates. Fees and foreign exchange rates may vary by brand, channel and location based on a number of factors. Fees and rates subject to change without notice. Subject to applicable taxes (if any). Money transfers sent to Lebanon are subject to a 2% cash handling fee which will be collected from the principal amount during payout in USD at the agent location.',
  termsLinkText: 'terms and conditions for details.',
  successfullyTransaction: 'Successfully completed transaction!',
  successfullyTransactionText:
    'You have successfully sent the money. In order for the recipient to be able to withdraw the money, please follow the instructions below.',
  fixedText: 'Receiver will get fixed amount',
  failedTransaction: 'Transaction failed!',
  failedTransactionText:
    'Your transaction cannot be executed at this time. Please call the customer service center for further information.',
  suspendedTransactionTitle: 'Transaction is being audited',
  purpose1: 'Family Support/Living Expenses',
  purpose2: 'Gift',
  purpose3: 'Goods & Services payment/Commercial Transaction',
  purpose4: 'Travel expenses',
  purpose5: 'Education/School Fee',
  purpose6: 'Rent/Mortgage',
  purpose7: 'Emergency/Medical Aid',
  purpose8: 'Charity/Aid Payment',
  unsuccessfullyPayment: 'We are sorry, we were unable to charge your payment.',
  rejectedTransaction:
    'Your transaction was rejected. Please contact Customer Service Center for further information - 011 333 4 999.',
  timeoutTransaction:
    'Your transaction was not completed within the expected time. Please contact the Customer Center for further information - 011 333 4 999.',
  suspendedTransaction:
    'Your transaction is being audited, please call the Customer Center for further information - 011 333 4 999.',

  // Pages
  homePageTitle: 'Home | Western union',
  sendMoneyPageTitle: 'Send money | Western union',
  historyOfTransactionsPage: `History of transactions | Western union`,
  personalInfoPage: 'Personal info | Western union',
  userDataPage: 'User data | Western union',
  transactionShowPage: 'Transaction details | Western union',
  completedTransactionPage: 'Completed transaction | Western union',
  registerPage: 'Register | Western union',
  loginPage: 'Login | Western union',
  saveUserDetailsPage: 'Save user details | Western union',
  failedTransactionPage: 'Failed transaction | Western union',

  // Validation

  minimumAmount: 'Amount can be minimum ',
  maxLength: 'Max length of field is ',

  // Global
  applicationError: 'An error has occurred, please try again later.',
  loading: 'Loading',
  invalidField: 'Invalid field',

  // Footer
  sendMoneyWithWuOnline: 'Send money via WU online',
  withJustAFewClicks: 'With just a few clicks, from the comfort of your own home.',
  support: 'Support',
  aboutUs: 'About us',
  info: 'Info',
  pricing: 'Pricing',
  pricingUrl: '/docs/pricing-sr.pdf',
  tf_home_link: 'https://www.tenfore.rs/en/homepage',
  wu_home_link: 'https://www.westernunion.com/global/',

  footer_cta_title: 'Send Money with WU Online',
  footer_cta_subtitle: 'With a few clicks from the comfort of your home.',
  footer_cta: 'Send Money',
  footer_phone: 'Phone',
  footer_support: 'Support',
  footer_customer_support: 'Customer Support',
  footer_faq: 'Frequently Asked Questions',
  footer_about_us: 'About Us',
  footer_about_WU: 'About Western Union',
  footer_about_tenfore: 'About Tenfore Payment Institution',
  footer_our_service: 'Our Services',
  footer_nbs_licence: 'NBS License',
  footer_info: 'Info',
  footer_send_with_WU: 'Send Money with WUONLINE',
  footer_protection: 'Fraud Protection',
  footer_ways_to_send: 'Ways to Send Money',
  footer_WU_instructions: 'WUONLINE Money Sending Guide',
  footer_registration_instructions: 'Registration Guide',
  footer_track_transfer: 'Track Your Transfer',
  footer_privacy_policy: 'Privacy Policy',
  footer_terms_of_use: 'Terms of Use',
  footer_terms_of_use_url: '/docs/terms-and-conditions-en-2025.pdf',
  footer_new_terms_of_use: 'Terms of Use - 2026',
  footer_new_terms_of_use_url: '/docs/terms-and-conditions-en-2026.pdf',
  footer_general_terms: 'General Terms',
  footer_general_terms_url: '/docs/general-terms-and-conditions-en.pdf',
  footer_pricing: 'Pricing',
  footer_pricing_url: '/docs/pricing-en.pdf',
  footer_data_collection: 'Notice of Personal Data Collection and Processing',
  footer_data_collection_url: '/docs/notification-on-data-en.pdf',
  footer_privacy_policy_url: 'https://www.westernunion.com/global/en/privacy-statement.html',
  footer_customer_support_url: 'https://www.tenfore.rs/en/for-customers/contact',
  footer_protection_url:
    'https://www.tenfore.rs/en/for-customers/western-union/fraud-and-user-protection',
  footer_faq_url: 'https://www.tenfore.rs/en/for-customers/faq',
  footer_ways_to_send_url: 'https://www.tenfore.rs/en/for-customers/western-union#c3620',
  footer_about_WU_url: 'https://www.tenfore.rs/en/about-us/about-western-union',
  footer_WU_instructions_url: 'https://www.tenfore.rs/en/for-customers/western-union#c3618',
  footer_registration_instructions_url:
    'https://www.tenfore.rs/en/for-customers/western-union#c3618',
  footer_track_transfer_url: 'https://www.westernunion.com/web/global-service/track-transfer',
  footer_about_tenfore_url: 'https://www.tenfore.rs/en/about-us/about-us',
  footer_our_service_url: 'https://www.tenfore.rs/en/about-us/services',
  footer_nbs_licence_url:
    'https://www.tenfore.rs/en/about-us/licence-of-the-national-bank-of-serbia',

  complaints: 'Complaints',
  complaints_url: 'https://transfernovca.rs/en/for-customers/complaints',

  // Footer links
  faq: 'Frequently asked questions',
  aboutWu: 'About Western Union',
  aboutTenfore: 'About Tenfore payment institution',
  aboutServices: 'Our services',
  libenceNbs: 'NBS licence',
  sendMoneyWithWu: 'Send money via WUONLINE',
  fraudProtection: 'Fraud protection',
  typeOfSendMoney: 'How to send a money transfer',
  sendMoneyGuide: 'WUONLINE sending money guide',
  registrationGuide: 'Registration guide',
  trackOwnTransfer: 'Track your transfer',
  statementPolicy: 'Privacy statement',
  termsOfUse: 'Profile terms',
  generalTerms: 'Terms and conditions',
  noticeOnCollectionAndProcessingOfPersonalData:
    'Notification on personal data collection and processing for one-time payment transaction',

  customerSupportUrl: 'https://www.tenfore.rs/en/for-customers/contact',
  faqUrl: 'https://www.tenfore.rs/en/for-customers/faq',
  aboutWuUrl: 'https://www.tenfore.rs/en/about-us/about-western-union',
  aboutTenforeUrl: 'https://www.tenfore.rs/en/about-us/about-us',
  aboutServicesUrl: 'https://www.tenfore.rs/en/about-us/services ',
  libenceNbsUrl: 'https://www.tenfore.rs/en/about-us/licence-of-the-national-bank-of-serbia',
  fraudProtectionUrl:
    'https://www.tenfore.rs/en/for-customers/western-union/fraud-and-user-protection',
  typeOfSendMoneyUrl: 'https://www.tenfore.rs/en/for-customers/western-union#c3620',
  sendMoneyGuideUrl: 'https://www.tenfore.rs/en/for-customers/western-union#c3618',
  registrationGuideUrl: 'https://www.tenfore.rs/en/for-customers/western-union#c3618',
  statementPolicyUrl: 'https://www.westernunion.com/global/en/privacy-statement.html',
  trackOwnTransferUrl: 'https://www.westernunion.com/web/global-service/track-transfer',

  notificationOnDataUrl: '/docs/notification-on-data-sr.pdf',
  generalTermsAndConditionsUrl: '/docs/general-terms-and-conditions-sr.pdf',
  termsAndConditionsUrl: '/docs/terms-and-conditions-sr.pdf',
  tenforeLocationsUrl: 'https://www.tenfore.rs/en/locations?sending_online=3#mapHash',

  CREATED: 'Created',
  VALIDATED: 'Validated',
  VALIDATION_FAILED: 'Validated failed',
  PASSED_AML: 'Passed AML',
  FAILED_AML: 'Failed AML',
  BLOCKED_AML: 'Blocked AML',
  SUSPENDED_AML: 'Suspended AML',
  RISK_LIMIT_SET: 'Risk limit set',
  RISK_LIMIT_SET_FAILED: 'Risk limit set failed',
  SENT: 'Sent',
  SEND_FAILED: 'Send failed',
  CHARGED: 'Charged',
  CHARGE_FAILED: 'Charge failed',
  EVENT_PUBLISHED: 'Event published',
  EVENT_PUBLISH_FAILED: 'Event published failed',

  // Fraud protection

  howToProtectYourself: 'How to protect yourself',
  pleaseBeAware:
    'Please be aware that scams can happen if you do not know the person you are sending money to!',
  doNotSendMoney: 'Do not send money through Western Union for the following:',
  doNotSendFirstPar:
    'For a purchase of goods/ services over the Internet – e.g. car purchase, usually at a more favorable price than the market price;',
  doNotSendSecondPar: 'For costs incurred as a way of receiving some inheritance;',
  doNotSendThirdPar: 'To participate in a lottery or prize winning;',
  doNotSendFourPar: 'For a rental property;',
  doNotSendFivePar: 'For an employment proposal;',
  doNotSendSixPar: 'To cover costs incurred to receive a visa or a permit to work abroad;',
  doNotSendSevenPar:
    'To cover travelling costs of a person you have met through social networks and websites;',
  doNotSendEightPar:
    'To help a friend or a family member, due to an SMS message or e-mail, which plead you send money for an emergency;',
  doNotSendNinePar:
    'For cheque withdrawal of a cheque deposited in your name and which takes time to be cashed.',
  ourAdvice: 'Our advice:',
  ourAdviceFirstPar: 'Send money only to persons you know well and trust.',
  ourAdviceSecondPar:
    'Details of your transfer are confidential and you should not share them with any other person but the Receiver.',
  ourAdviceThirdPar:
    'If you are not able to establish the identity of the person who contacted you prior to sending, do not send money.',
  ourAdviceFourPar:
    'If the offer sounds too good to be true, it is possible that fraud is involved.',
  ourAdviceFivePar:
    'A money transfer can be paid out to the Receiver within a very short time. After the money has been paid, you cannot obtain a refund from Western Union, even if the transfer was a result of fraud.',
  ourAdviceSixPar:
    'Once you have sent the money, there is no way to delay payment if you change the first and last name of the Receiver or destination country, or if you do not inform the Receiver about the Money Transfer Control Number (MTCN).',
  ourAdviceSevenPar:
    'Should you like to obtain more information about the Western Union service or if you sent money via Western Union and think you may be a victim of fraud, call our Customer Service Center at: 011/333 4 999.',
  IdData: 'ID Document Information',
  ResidenceAddress: 'Residence Address',
  Registration: 'Registration',
  Other: 'Other',
  RegistrationDescription:
    'Your email address and phone number have already been registered. Please complete the form below to complete your user profile and enable further access to the application.\n',
  Report_feedback: 'Report feedback',
};
